/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LavoriResponseDTO
 */
export interface LavoriResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof LavoriResponseDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {string}
     * @memberof LavoriResponseDTO
     */
    commessa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LavoriResponseDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LavoriResponseDTO
     */
    oreLavorate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LavoriResponseDTO
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof LavoriResponseDTO
     */
    data?: Date;
}

/**
 * Check if a given object implements the LavoriResponseDTO interface.
 */
export function instanceOfLavoriResponseDTO(value: object): value is LavoriResponseDTO {
    return true;
}

export function LavoriResponseDTOFromJSON(json: any): LavoriResponseDTO {
    return LavoriResponseDTOFromJSONTyped(json, false);
}

export function LavoriResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LavoriResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'commessa': json['commessa'] == null ? undefined : json['commessa'],
        'note': json['note'] == null ? undefined : json['note'],
        'oreLavorate': json['oreLavorate'] == null ? undefined : json['oreLavorate'],
        'allowEdit': json['allowEdit'] == null ? undefined : json['allowEdit'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
    };
}

export function LavoriResponseDTOToJSON(json: any): LavoriResponseDTO {
    return LavoriResponseDTOToJSONTyped(json, false);
}

export function LavoriResponseDTOToJSONTyped(value?: LavoriResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'commessa': value['commessa'],
        'note': value['note'],
        'oreLavorate': value['oreLavorate'],
        'allowEdit': value['allowEdit'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
    };
}

